// import { useState, useEffect } from "react";
// import axios from "axios";
// import Dashboard from "../../Templates/Dashboard";
import "../../../assets/css/global.css";
// import { useKeycloak } from "@react-keycloak/web";

// const authUrl = process.env.REACT_APP_AUTH_API_URL;

const DashboardPage = () => {
  // const { keycloak } = useKeycloak();
  // const accessToken = keycloak.token;

  // const fetchSpentTokens = async () => {
  //   try {
  //     const { data } = await axios.get(
  //       authUrl + "/metrics/spent-tokens-by-user",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       }
  //     );
  //     return data;
  //   } catch (error) {
  //     console.error("Error:", error);
  //     return [];
  //   }
  // };

  // const fetchInteractions = async () => {
  //   try {
  //     const response = await axios.get(
  //       authUrl + "/metrics/interactions-by-context-and-user",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       }
  //     );
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error:", error);
  //     return [];
  //   }
  // };

  // const [dataSpentTokens, setDataSpentTokens] = useState([]);
  // const [dataInteractions, setDataInteractions] = useState([]);
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const spentTokens = await fetchSpentTokens();
  //     const interactions = await fetchInteractions();

  //     setDataSpentTokens(spentTokens);
  //     setDataInteractions(interactions);
  //     setLoading(false);
  //   };

  //   if (accessToken) {
  //     fetchData();
  //   }
  // }, [accessToken]);

  // return (
  //   <div className="main vh-100">
  //     {loading ? (
  //       <div className="d-flex justify-content-center align-items-center h-100">
  //         <div className="spinner-border text-primary" role="status">
  //           <span className="visually-hidden">Loading...</span>
  //         </div>
  //       </div>
  //     ) : (
  //       <Dashboard
  //         dataSpentTokens={dataSpentTokens}
  //         dataInteractions={dataInteractions}
  //       />
  //     )}
  //   </div>
  // );

  return (
    <div className="alert alert-warning" role="alert">
      <h4 className="alert-heading">Atualização em Progresso!</h4>
      <p>
        Estamos atualizando o painel de dashboard e ele pode ficar fora do ar
        temporariamente. Obrigado pela compreensão!
      </p>
    </div>
  );
};

export default DashboardPage;

// TODO: Atualizar comunicação com API
